import angular from 'angular';

angular
  .module('cxSettings')
  .controller('ReorderSubtaskTemplatesDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'template',
    'initialMove',
    reorderSubtaskTemplatesDialogCtrl,
  ]);

function reorderSubtaskTemplatesDialogCtrl(
  $element,
  $http,
  appUrls,
  flySvc,
  close,
  template,
  initialMove,
) {
  var vm = this;
  vm.template = template;
  vm.saving = false;
  vm.dirty = false;
  vm.subtasks = (template.children || [])
    .filter(subtask => !subtask.isRemoved)
    .slice()
    .sort((a, b) => (a.priority || 0) - (b.priority || 0))
    .map(subtask => ({ id: subtask.id, name: subtask.name }));

  function moveTo(index, target) {
    if (target < 0 || target >= vm.subtasks.length || target === index) return;
    var [subtask] = vm.subtasks.splice(index, 1);
    vm.subtasks.splice(target, 0, subtask);
    vm.dirty = true;
  }

  vm.moveUp = index => moveTo(index, index - 1);
  vm.moveDown = index => moveTo(index, index + 1);

  // The arrow the user clicked in the list is applied as the first move, so the dialog opens
  // showing its effect instead of asking for the click again.
  if (initialMove && initialMove.subtaskId) {
    var index = vm.subtasks.findIndex(subtask => subtask.id === initialMove.subtaskId);
    if (index >= 0) moveTo(index, initialMove.up ? index - 1 : index + 1);
  }

  vm.save = function() {
    if (!vm.dirty) {
      vm.cancel();
      return;
    }
    vm.saving = true;
    $http
      .put(`${appUrls.tasks}/api/tasktemplates/${vm.template.id}/subtasks/order`, {
        subtaskTemplateIds: vm.subtasks.map(subtask => subtask.id),
      })
      .then(
        function({ data }) {
          $element.modal('hide');
          close(data, 500);
          flySvc.success();
        },
        function(error) {
          vm.saving = false;
          flySvc.error(error);
        },
      );
  };

  vm.cancel = function() {
    close(null, 500);
  };
}
